export default __webpack_public_path__ + "static/media/chat-alt-2-o.913dd596.svg";